(function () {
  const STEPS = [
    {
      id: 'goal',
      question: 'What do you want to focus on first?',
      options: [
        { value: 'hair', label: 'Scalp & hair care' },
        { value: 'face', label: 'Clear, gentle skin' },
        { value: 'both', label: 'Complete face + hair routine' },
      ],
    },
    {
      id: 'time',
      question: 'How much time can you give daily?',
      options: [
        { value: 'quick', label: '2 min — quick daily step' },
        { value: 'moderate', label: 'Daily + weekly oiling' },
        { value: 'full', label: 'Full ritual (daily + wash days)' },
      ],
    },
    {
      id: 'start',
      question: 'How do you prefer to start?',
      options: [
        { value: 'single', label: 'One hero product' },
        { value: 'duo', label: 'Starter duo (best value)' },
        { value: 'kit', label: 'Complete kit' },
      ],
    },
  ];

  const COPY = {
    'hair-toner-100ml': {
      title: 'Hair Toner',
      blurb: 'Daily scalp spray — no oiling needed. Ideal first step for scalp care.',
    },
    'magical-hair-oil': {
      title: 'Magical Hair Oil',
      blurb: 'Weekly nourishment for roots and length.',
    },
    'nature-s-secret-homemade-herbal-hair-shampoo': {
      title: 'Herbal Shampoo',
      blurb: 'Gentle cleanse for wash days.',
    },
    'daily-hair-refresh-kit': {
      title: 'Scalp Nourish Duo',
      blurb: 'Toner + oil — daily care plus weekly nourishment.',
    },
    'hair-care-duo-oil-shampoo': {
      title: 'Hair Care Duo',
      blurb: 'Oil + shampoo for wash-day and weekly rituals.',
    },
    'complete-hair-ritual-kit': {
      title: 'Complete Hair Ritual Kit',
      blurb: 'Toner, oil & shampoo — our full herbal hair routine.',
    },
    'aaramya-herbal-facewash': {
      title: 'Herbal Facewash',
      blurb: 'Gentle daily cleanser for clear, healthy skin.',
    },
    'aaramya-essentials-kit': {
      title: 'Aaramya Essentials Kit',
      blurb: 'Facewash plus full hair line — everything in one kit.',
    },
  };

  function pickHandle(answers) {
    const g = answers.goal;
    const t = answers.time;
    const s = answers.start;

    if (g === 'face') return 'aaramya-herbal-facewash';
    if (g === 'both') {
      if (s === 'single') return 'aaramya-herbal-facewash';
      return 'aaramya-essentials-kit';
    }

    if (s === 'single') {
      if (t === 'quick') return 'hair-toner-100ml';
      if (t === 'moderate') return 'magical-hair-oil';
      return 'nature-s-secret-homemade-herbal-hair-shampoo';
    }
    if (s === 'duo') {
      if (t === 'quick') return 'daily-hair-refresh-kit';
      return 'hair-care-duo-oil-shampoo';
    }
    return 'complete-hair-ritual-kit';
  }

  function initQuiz(root) {
    const stepsEl = root.querySelector('[data-quiz-steps]');
    const resultEl = root.querySelector('[data-quiz-result]');
    const progressEl = root.querySelector('[data-quiz-progress]');
    const backBtn = root.querySelector('[data-quiz-back]');
    if (!stepsEl || !resultEl) return;

    let step = 0;
    const answers = {};

    function renderProgress() {
      if (!progressEl) return;
      progressEl.innerHTML = STEPS.map(
        (_, i) =>
          `<span class="aa-quiz__dot${i <= step ? ' is-active' : ''}${i < step ? ' is-done' : ''}"></span>`
      ).join('');
    }

    function renderStep() {
      renderProgress();
      if (backBtn) backBtn.hidden = step === 0;
      const s = STEPS[step];
      stepsEl.innerHTML = `
        <p class="aa-quiz__step-label">Step ${step + 1} of ${STEPS.length}</p>
        <h3 class="aa-quiz__question">${s.question}</h3>
        <div class="aa-quiz__options">
          ${s.options
            .map(
              (o) =>
                `<button type="button" class="aa-quiz__opt" data-value="${o.value}">${o.label}</button>`
            )
            .join('')}
        </div>`;
      stepsEl.hidden = false;
      resultEl.hidden = true;
      stepsEl.querySelectorAll('.aa-quiz__opt').forEach((btn) => {
        btn.addEventListener('click', () => {
          answers[s.id] = btn.dataset.value;
          step += 1;
          if (step >= STEPS.length) showResult();
          else renderStep();
        });
      });
    }

    function showResult() {
      const handle = pickHandle(answers);
      const meta = COPY[handle] || { title: 'Your match', blurb: '' };
      stepsEl.hidden = true;
      resultEl.hidden = false;
      if (progressEl) {
        progressEl.innerHTML =
          '<span class="aa-quiz__dot is-active is-done"></span>'.repeat(3);
      }
      resultEl.innerHTML = `
        <p class="aa-quiz__eyebrow">Your ritual match</p>
        <h3 class="aa-quiz__result-title" data-quiz-result-title>${meta.title}</h3>
        <p class="aa-quiz__result-blurb">${meta.blurb}</p>
        <div class="aa-quiz__result-card" data-quiz-result-card>
          <p class="aa-quiz__loading">Loading recommendation…</p>
        </div>
        <div class="aa-quiz__result-actions">
          <a href="/products/${handle}" class="aa-quiz__btn aa-quiz__btn--primary" data-quiz-view>View product</a>
          <button type="button" class="aa-quiz__btn aa-quiz__btn--ghost" data-quiz-retry>Retake quiz</button>
        </div>
        <p class="aa-quiz__result-reassure">Free delivery above ₹499 · Cash on delivery · Patch test before first use</p>`;

      fetch(`/products/${handle}.js`)
        .then((r) => (r.ok ? r.json() : null))
        .then((p) => {
          const card = resultEl.querySelector('[data-quiz-result-card]');
          if (!p || !card) return;
          const v = p.variants && p.variants[0];
          let price = '';
          if (v && v.price != null) {
            const current =
              '₹' + (Number(v.price) / 100).toLocaleString('en-IN');
            const compare = v.compare_at_price;
            if (compare && Number(compare) > Number(v.price)) {
              const was =
                '₹' + (Number(compare) / 100).toLocaleString('en-IN');
              price = `<span class="aa-product-price"><span class="aa-product-price__compare">${was}</span><span class="aa-product-price__current">${current}</span></span>`;
            } else {
              price = `<span class="aa-product-price"><span class="aa-product-price__current">${current}</span></span>`;
            }
          }
          const titleEl = resultEl.querySelector('[data-quiz-result-title]');
          if (titleEl) titleEl.textContent = p.title;
          card.innerHTML = `
            <a href="/products/${handle}" class="aa-quiz__result-link">
              ${p.featured_image ? `<img src="${p.featured_image}" alt="" width="120" height="120" loading="lazy">` : ''}
              <span>
                <strong>${p.title}</strong>
                <span class="aa-quiz__result-price">${price}</span>
              </span>
            </a>
            <a href="/products/${handle}?variant=${v.id}" class="aa-quiz__btn aa-quiz__btn--primary aa-quiz__btn--block" data-quiz-add>Add to cart</a>`;
          const add = card.querySelector('[data-quiz-add]');
          if (add) {
            add.addEventListener('click', (e) => {
              e.preventDefault();
              add.textContent = 'Adding…';
              fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                credentials: 'same-origin',
                body: JSON.stringify({ id: v.id, quantity: 1 }),
              })
                .then((r) => r.json())
                .then(() => {
                  document.dispatchEvent(new CustomEvent('cart:update'));
                  const done = document.createElement('a');
                  done.href = '/cart';
                  done.className =
                    'aa-quiz__btn aa-quiz__btn--primary aa-quiz__btn--block';
                  done.setAttribute('data-quiz-added', '1');
                  done.textContent = 'Added ✓ — View cart';
                  add.replaceWith(done);
                })
                .catch(() => {
                  add.textContent = 'Add to cart';
                });
            });
          }
        })
        .catch(() => {
          const card = resultEl.querySelector('[data-quiz-result-card]');
          if (card) card.innerHTML = '';
        });

      resultEl.querySelector('[data-quiz-retry]')?.addEventListener('click', () => {
        step = 0;
        Object.keys(answers).forEach((k) => delete answers[k]);
        renderStep();
      });
    }

    if (backBtn) {
      backBtn.addEventListener('click', () => {
        if (step > 0) {
          step -= 1;
          renderStep();
        }
      });
    }

    renderStep();
  }

  document.querySelectorAll('[data-aa-ritual-quiz]').forEach(initQuiz);
})();
